import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";

const LOWER_BOUND_DATE = new Date(0);
const UPPER_BOUND_DATE = new Date(8640000000000000);

/**
 * Es un componente dedicado a los input de tipo date
 */
const InputDate = ({
  inputLabel = "inputLabel",
  inputField,
  required,
  onChange,
  disabled,
  readOnly,
  extraStyle = "",
  id,
  year,
  disableDatesBefore,
  disableDatesAfter,
  ...props
}) => {
  const [disabledDates, setDisabledDates] = useState([]);
  const [val, setVal] = useState(inputField);
  const [isFocused, setIsFocused] = useState(false);
  // Generar los rangos min y max para los inputs date
  const today = new Date();
  const currentYear = today.getFullYear(); // Año actual

  useEffect(() => {
    setVal(inputField);
  }, [inputField]);
  

useEffect(() => {
  if (year < currentYear) {
    setVal(new Date(year, 6, 15)); // Año posterior, 15 de julio
  }else{
    setVal(new Date()); // Año actual, fecha actual
  }

  // Verificar si el año seleccionado es el mismo que el año actual
  const excludeIntervals = year === currentYear
      ? [
          // Si es el año actual, excluimos fechas antes de este año y después de hoy
          { start: LOWER_BOUND_DATE , end: new Date(year - 1, 11, 31) }, // Fechas antes del 1 de enero del año actual
          { start: new Date(today.setDate(today.getDate())), end: UPPER_BOUND_DATE } // Fechas después de hoy
      ]
      : [
          // Si no es el año actual, excluimos fechas fuera del año seleccionado
          { start: LOWER_BOUND_DATE, end: new Date(year - 1, 11, 31) }, // Fechas antes del 1 de enero del año seleccionado
          { start: new Date(year + 1, 0, 1), end: UPPER_BOUND_DATE } // Fechas después del 31 de diciembre del año seleccionado
      ]

  setDisabledDates(excludeIntervals);
}, [year]);



  useEffect(() => {
    if (val) {
      setIsFocused(true)
    } else {
      setIsFocused(false)
    }
  }, [val]);

  const handleFocus = (event) => {
    setIsFocused(true);
  };

  const handleBlur = (event) => {
    val ? setIsFocused(true): setIsFocused(false);
  };

   // Función para formatear la fecha en formato "YYYY-MM-DD HH:mm"
  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Mes en formato 2 dígitos
    const day = String(date.getDate()).padStart(2, "0"); // Día en formato 2 dígitos
    const hours = String(date.getHours()).padStart(2, "0"); // Horas en formato 2 dígitos
    const minutes = String(date.getMinutes()).padStart(2, "0"); // Minutos en formato 2 dígitos
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  return (
      <DatePicker
        showTimeSelect
        selected={val}
        dateFormat="dd/MM/yyyy HH:mm aa"
        onChange={onChange}
        excludeDateIntervals={disabledDates}
        customInput={
          <div className={`form-group ${isFocused ? "focused" : ""}`}>
            <label className="form-label" htmlFor={id}>
              {inputLabel}
            </label>
            <input
            id={id}
            className={`form-input ${val ? "has-value" : ""} ${
              extraStyle !== "" ? extraStyle : ""
            }`}
            type={"text"} // Cambiado a "text" para mostrar el valor formateado
            name={inputLabel}
            onFocus={handleFocus}
            onBlur={handleBlur}
            readOnly
            {...props}
            disabled={disabled}
            required={required}
          />
          </div>
        }

      />
      
  );
};

export default InputDate;
